module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mine-customer"
  }, [_c('div', [_c('van-notice-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alert_str),
      expression: "alert_str"
    }],
    attrs: {
      "left-icon": "volume-o",
      "text": _vm.alert_str
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-header"
  }, [_c('img', {
    staticStyle: {
      "position": "fixed",
      "top": "10px",
      "left": "20px",
      "width": "160px"
    },
    attrs: {
      "src": "https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20220529/user-0/20220529/97f89c9abe0b1ef84e20d4bb8e1cb11c.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-message"
  }, [_c('div', {
    staticClass: "user-detail"
  }, [_c('div', {
    staticClass: "user-detail-right"
  }, [_c('div', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.row.XM_ZB) + "（" + _vm._s(_vm.row.XM_BH) + "）")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#666",
      "margin": "0 0 6px 0"
    }
  }, [_vm._v("项目名称 "), _c('em', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v(_vm._s(_vm.row.XM_MC))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#666",
      "margin": "0 0 6px 0"
    }
  }, [_vm._v("开 发 商  "), _c('em', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v(_vm._s(_vm.row.XM_KFS))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#666",
      "margin": "0 0 6px 0"
    }
  }, [_vm._v("项目地址 "), _c('em', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v(_vm._s(_vm.row.XM_DZ))]), _vm._v(" "), _c('button', {
    staticStyle: {
      "background": "#1989fa",
      "padding": "0 6px",
      "color": "#fff",
      "border-radius": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.toMap()
      }
    }
  }, [_vm._v("地图导航")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#666",
      "margin": "0 0 6px 0"
    }
  }, [_vm._v("设备厂商 "), _c('em', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v(_vm._s(_vm.row.SBCS))])]), _vm._v(" "), _c('div', {
    staticClass: "user-invite",
    staticStyle: {
      "color": "#666"
    },
    on: {
      "click": _vm.change
    }
  }, [_vm._v("\n                工地喷淋（" + _vm._s(_vm.row.XM_BH) + "）\n                "), _c('img', {
    attrs: {
      "src": require("../../../assets/images/weiyuanhui/icon-qiehuan.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "invite-num"
  }, [_vm._v("[切换设备]")])])]), _vm._v(" "), _c('div', {
    staticClass: "user-setting-box",
    on: {
      "click": _vm.toBusinessSet
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/weiyuanhui/icon-seeting.png"),
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "user-black flex-between",
    on: {
      "click": _vm.toWeiyuanhuiDetail
    }
  }, [_c('div', {
    staticClass: "user-black-top"
  }, [_c('div', {
    staticClass: "user-moneys"
  }, [_c('div', {
    staticClass: "user-moneys-title"
  }, [_vm._v("低水位报警")]), _vm._v(" "), (_vm.row.SWZT == 1) ? _c('div', [_vm._v("水位正常")]) : _c('div', [_vm._v("水位过低")])]), _vm._v(" "), _c('div', {
    staticClass: "user-moneys",
    on: {
      "click": _vm.toWeiyuanhuiDetail
    }
  }, [_c('div', {
    staticClass: "user-moneys-title"
  }, [_vm._v("喷淋状态")]), _vm._v(" "), (_vm.row.PLZT == 1) ? _c('div', [_vm._v("喷淋中")]) : _c('div', [_vm._v("停止中")])])]), _vm._v(" "), _c('div', {
    staticClass: "user-black-middle"
  }), _vm._v(" "), _c('div', {
    staticClass: "user-black-top"
  }, [_c('div', {
    staticClass: "user-moneys",
    on: {
      "click": _vm.toWeiyuanhuiDetail
    }
  }, [_c('div', {
    staticClass: "user-moneys-title"
  }, [_vm._v("PM25浓度")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.row.PM25)), _c('em', [_vm._v("mg/m³")])])]), _vm._v(" "), _c('div', {
    staticClass: "user-moneys"
  }, [_c('div', {
    staticClass: "user-moneys-title"
  }, [_vm._v("PM10浓度")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.row.PM10)), _c('em', [_vm._v("mg/m³")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "credit-box"
  }, [_c('div', {
    staticClass: "credit-ul"
  }, [_c('div', {
    staticClass: "credit-li"
  }, [_c('span', [_vm._v(_vm._s(_vm.row['RUN_Info:nIa'] / 100))]), _vm._v(" "), _c('em', [_vm._v("A")]), _vm._v(" "), _c('div', {
    staticClass: "credit-text"
  }, [_vm._v("A相电流")])]), _vm._v(" "), _c('div', {
    staticClass: "credit-li"
  }, [_c('span', [_vm._v(_vm._s(_vm.row['RUN_Info:nIb'] / 100))]), _vm._v(" "), _c('em', [_vm._v("A")]), _vm._v(" "), _c('div', {
    staticClass: "credit-text"
  }, [_vm._v("B相电流")])]), _vm._v(" "), _c('div', {
    staticClass: "credit-li"
  }, [_c('span', [_vm._v(_vm._s(_vm.row['RUN_Info:nIc'] / 100))]), _vm._v(" "), _c('em', [_vm._v("A")]), _vm._v(" "), _c('div', {
    staticClass: "credit-text"
  }, [_vm._v("C相电流")])])]), _vm._v(" "), _c('div', {
    staticClass: "credit-all"
  }, [_c('div', {
    staticClass: "credit-all-left"
  }, [_vm._v("\n           低水位状态\n           "), (_vm.row['RUN_Info:dsw_state'] == 0) ? _c('span', {
    staticClass: "order-num"
  }, [_vm._v("\n              低水位\n             ")]) : _c('span', {
    staticClass: "order-num"
  }, [_vm._v("\n              水位正常\n             ")])]), _vm._v(" "), _c('div', {
    staticClass: "credit-all-right"
  }, [_vm._v("\n           运行模式 \n             \n           "), (_vm.row['RUN_Info:YX_model'] == 0) ? _c('span', {
    staticClass: "order-num"
  }, [_vm._v("\n              手动\n             ")]) : _c('span', {
    staticClass: "order-num"
  }, [_vm._v("\n              自动\n             ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "credit-box"
  }, [_c('div', {
    staticClass: "credit-ul"
  }, [_c('div', {
    staticClass: "credit-li"
  }, [_c('span', [_vm._v(_vm._s(_vm.row['RUN_Info:PL_time'] / 10) + " ")]), _c('em', [_vm._v("s")]), _vm._v(" "), _c('div', {
    staticClass: "credit-text"
  }, [_vm._v("喷淋时长")])]), _vm._v(" "), _c('div', {
    staticClass: "credit-li"
  }, [_c('span', [_vm._v(_vm._s(_vm.row['RUN_Info:ZT_time'] / 10) + " ")]), _c('em', [_vm._v("s")]), _vm._v(" "), _c('div', {
    staticClass: "credit-text"
  }, [_vm._v("暂停时长")])]), _vm._v(" "), _c('div', {
    staticClass: "credit-li"
  }, [_c('span', [_vm._v(_vm._s(_vm.row['RUN_Info:QSFW_time'] / 10) + " ")]), _c('em', [_vm._v("s")]), _vm._v(" "), _c('div', {
    staticClass: "credit-text"
  }, [_vm._v("缺水复位时间")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "mini-nav"
  }, [_c('ul', [(_vm.row['RUN_Info:YX_model'] == 1) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.setStatus('Remote_config:WindSpeed', 0)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/weiyuanhui/icon-caipanyaunguanli.png"),
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(0)]) : _c('li', {
    on: {
      "click": function($event) {
        return _vm.setStatus('Remote_config:WindSpeed', 1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/weiyuanhui/icon-caipanyaunguanli.png"),
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.setStatus('Remote_config:Reset', 1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/weiyuanhui/icon-caipanyaunguanli.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("报警复位")])]), _vm._v(" "), (_vm.row['PLZT'] == 0) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.setStatus('Remote_config:Spray', 1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/weiyuanhui/icon-caipanyaunguanli.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("开启喷淋")])]) : _c('li', {
    on: {
      "click": function($event) {
        return _vm.setStatus('Remote_config:Spray', 0)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/weiyuanhui/icon-caipanyaunguanli.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("关闭喷淋")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.toVideo()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/weiyuanhui/icon-julebu.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("监控视频")])])])]), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("模式设置"), _c('br'), _vm._v("(切换成手动)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("模式设置"), _c('br'), _vm._v("(切换成自动)")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8dd9fdc2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/weiyuanhui/index/Devicetest.vue
// module id = 2544
// module chunks = 0